import { render, staticRenderFns } from "./HeadingComponent.vue?vue&type=template&id=be8658ea&scoped=true&"
import script from "./HeadingComponent.vue?vue&type=script&lang=js&"
export * from "./HeadingComponent.vue?vue&type=script&lang=js&"
import style0 from "./HeadingComponent.vue?vue&type=style&index=0&id=be8658ea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be8658ea",
  null
  
)

export default component.exports